<template>
	<b-modal
		ref="modal"
		no-close-on-backdrop
		centered
		hide-footer
		:title="bonus.id ? 'Edit bonus' : 'New bonus'"
		:modal-class="theme"
	>
		<BonusEdit
			:bonus="bonus"
			:error="errorMsg"
			:loading="loading"
			v-on:request-save="onRequestSave"
			v-on:close="hide"
		/>
	</b-modal>
</template>

<script>
import BonusEdit from "./BonusEdit";
import BonusService from "../../services/bonus";
import ThemeService from '../../services/theme';

export default {
	name: "BonusEditDialog",
	components: {
		BonusEdit,
	},
	data: function () {
		return {
			bonus: {},
			errorMsg: null,
			loading: false,
			theme: "light",
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		show: function (bonus) {
			this.bonus = bonus;
			this.$refs.modal.show();
		},
		hide: function () {
			this.errorMsg = null;
			this.$refs.modal.hide();
		},
		onRequestSave: function (bonus) {
			this.loading = true;
			BonusService.instance()
				.editBonus(bonus)
				.then(() => {
					this.loading = false;
					this.$emit("save-success");
					this.hide();
				})
				.catch((error) => {
					this.loading = false;
					this.errorMsg = error;
				});
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	},
};
</script>

<style>
</style>